export const changeDataProfileRoutes = {
  // Новые эндпоинты для нового API
  CHANGE_NAME: "/user/name", // PUT (новый API)
  GET_CODE_EMAIL: "/user/email/request-code", // POST (новый API) - запрос кода для изменения email
  CHANGE_EMAIL: "/user/email/confirm", // POST (новый API) - подтверждение изменения email с кодом
  CHANGE_PHONE: "/user/phone/request", // POST (новый API) - запрос кода для изменения телефона
};
